<section *ngIf="!!viewData && !attendanceView" class="train-ms-grey-box h-380px my-2">
    <!-- Session Basic Info -->
    <div *ngIf="viewData.sessionType != 'Material' && viewData.sessionType != 'Material_Text'" class="train-ms-white-box my-3">
        <div class="d-flex mx-1 my-2">
            <ng-container *ngIf="viewData.sessionType == 'Assessment'">
                <h6 class="t-main-b">{{ (viewData.assessment) ? viewData.assessment.name : viewData.title }}</h6>
            </ng-container>
            <ng-container *ngIf="viewData.sessionType == 'Survey'">
                <h6 class="t-main-b">{{ (viewData.survey) ? viewData.survey.name : viewData.title }}</h6>
            </ng-container>
            <ng-container *ngIf="viewData.sessionType !== 'Survey' && viewData.sessionType !== 'Assessment'">
                <h6 class="t-main-b">{{ viewData.title }}</h6>
            </ng-container>
        </div>
        <div *ngIf="viewData.sessionType != 'Video'" class="d-flex flex-wrap align-items-center">
            <div class="d-flex train-ms-grey-inner-box justify-content-center align-items-center">
                <div class="train-head">
                    {{ "the date" | translator }}
                </div>
                <div class="train-desc">{{viewData?.date | date}}</div>
            </div>
            <div *ngIf="viewData.sessionType != 'Video' "
                class="d-flex train-ms-grey-inner-box justify-content-center align-items-center">
                <div class="train-head">
                    {{ "Starting time" | translator }}
                </div>
                <div class="train-desc">
                    <span class="train-desc">{{viewData.start_time}}</span>
                </div>
            </div>
            <div *ngIf="viewData.sessionType != 'Video'"
                class="d-flex train-ms-grey-inner-box justify-content-center align-items-center">
                <div class="train-head">
                    {{ "end time" | translator }}
                </div>
                <div class="train-desc">{{viewData.end_time}}</div>
            </div>
            <div  *ngIf="viewData.sessionType != 'Survey' && viewData.sessionType != 'Assessment' && viewData.sessionType != 'Video'"  >
                <section class="d-flex train-ms-grey-inner-box justify-content-center align-items-center">
                    <div class="train-head">
                        {{ "the coach" | translator }}
                    </div>
                    <div class="train-desc">{{viewData?.trainer?.name}}</div>
                </section>
            </div>
        </div>
    </div>
    <!--  End Session Basic Info -->

    <!-- Online Session View -->
    <div *ngIf="viewData.sessionType == 'Onsite'" class="train-ms-white-box my-3">
        <div class="d-flex mx-1 my-2">
            <h6 class="t-main-b">{{ "In attendance" | translator }}</h6>
        </div>
        <div class="d-flex flex-wrap align-items-center">
            <div class="d-flex train-ms-grey-inner-box justify-content-center align-items-center">
                <div class="train-head">
                    {{ "Headquarters address" | translator }}
                </div>
                <div class="train-desc">{{viewData?.address}}</div>
            </div>
            <div class="d-flex train-ms-grey-inner-box justify-content-center align-items-center">
                <div class="train-head">
                    {{ "City" | translator }}
                </div>
                <div class="train-desc">
                    <span> {{viewData?.city}}</span>
                </div>
            </div>
            <div class="d-flex train-ms-grey-inner-box justify-content-center align-items-center">
                <div class="train-head">
                    {{ "Link" | translator }}
                </div>
                <div class="train-desc">
                    <a class="my-2 mt-0 label-data" [href]="viewData?.locationLink" target="_blank">
                        {{viewData?.locationLink}} </a>
                </div>
            </div>
        </div>
        <div *ngIf="viewData.history" class="d-flex mx-1 my-2">
            <h6 class="t-main-b">{{ "History Video" | translator }}</h6>
        </div>
        <app-content-view [viewOnly]="viewOnly" (sessionUpdate)="sessionUpdate($event)" [blockingVideo]="false"
            [session]="viewData" (videoError)="onVideoError()" [contentType]="contentType" [source]="source"
            [courseId]="courseId"></app-content-view>
    </div>

    <!-- Online Session -->
    <div *ngIf="viewData.sessionType == 'Online'" class="online-session-details">
        <p class="my-3 text-center">
            <span class="label-ui">
                {{ "The workshop will be held online" | translator }}
            </span>
        </p>
        <p class="my-3 text-center">
            <span class="label-ui"><i class="pi pi-link ml-2 mr-2 course-icon-ui"></i>
                {{ "Links" | translator }}</span>
        </p>
        <a [href]="viewData?.zoom_url" target="_blank">
            <div class="capsoul my-3 text-center">
                <a class="my-3 word-break-word color-white">
                    <span class="font-bold">{{ "Link to the workshop" | translator }} :</span>
                    {{viewData?.zoom_url}}</a>
            </div>
        </a>
        <div *ngIf="viewData.history" class="d-flex mx-1 my-2">
            <h6 class="t-main-b">{{ "History Video" | translator }}</h6>
        </div>
        <app-content-view [viewOnly]="viewOnly" (sessionUpdate)="sessionUpdate($event)" [blockingVideo]="false"
            [session]="viewData" (videoError)="onVideoError()" [contentType]="contentType" [source]="source"
            [courseId]="courseId"></app-content-view>
    </div>
    <!-- End Online Session -->

    <!-- Video and Course Material Session -->
    <div
        *ngIf="showView && (viewData.sessionType == 'Video' || this.viewData.sessionType == 'Material'|| this.viewData.sessionType == 'Material_Text' || this.viewData.sessionType == 'Survey' || this.viewData.sessionType == 'Assessment')">
        <p *ngIf="viewData.sessionType == 'Video'" class="my-3">
            <span class="label-ui"> {{ "Videos" | translator }}:</span>
        </p>
        <p *ngIf="viewData.sessionType == 'Material'" class="my-3">
            <span class="label-ui"> {{'name'|translator}}: {{viewData.title}}</span>
        </p>
        <app-content-view [viewOnly]="viewOnly" (sessionUpdate)="sessionUpdate($event)"
            [blockingVideo]="viewOnly && viewData.video_mode == 'Block'"
            [session]="viewData" (videoError)="onVideoError()" [contentType]="contentType" [source]="source"
            [courseId]="courseId"></app-content-view>
    </div>
    <!-- End Video Session -->

</section>

<section *ngIf="attendanceView" class="train-ms-grey-box h-380px my-2">
    <app-content-view [viewOnly]="viewOnly" [contentType]="contentType" [source]="source"
        [courseId]="courseId"></app-content-view>
</section>